import React from 'react';
import PropTypes from 'prop-types';
import { Typography, colors } from 'kangarootime-ui';
import './AttachmentUpload.css';

const Preview = ({ attachment }) => {
  const isImage = attachment.type.match(/image\//);

  return (
    <div className='attachment-preview-container'>
      { isImage
        ? <img
          alt={attachment.filename}
          src={URL.createObjectURL(attachment)}
          className='attachment-preview-image'
        />
        : <div className='attachment-preview-multi-media'>
          <div style={{ backgroundColor: colors.brand_2 }}>
            <span>file type icon</span>
          </div>
          <Typography type='bold' style={{ flex: 1, marginLeft: 4 }}>{attachment.name}</Typography>
        </div>
      }
    </div>
  );
};

Preview.propTypes = {
  attachment: PropTypes.instanceOf(File)
};

export default Preview;
